



















































import { Component } from "vue-property-decorator";
import UIkit from "uikit";
import Valance from "@/components/designer/sidebar/canopy/Valance.vue";
import * as option from "@/models/configurator/configurator_options";
import { mixins } from "vue-class-component";
import { CanopyStore } from "@/mixins/store";
import Standard from "../../../../assets/images/valance-standard.svg?inline";
import WhaleTail from "../../../../assets/images/valance-whale-tail.svg?inline";
import Scallop from "../../../../assets/images/valance-scallop.svg?inline";
import { StockMixin } from "@/mixins/stock";
import ValanceDisclaimer from "@/components/designer/reusable/ValanceDisclaimer.vue";

@Component({
  components: {
    Valance,
    Standard,
    WhaleTail,
    Scallop,
    ValanceDisclaimer
  }
})
export default class ValanceGroup extends mixins(CanopyStore, StockMixin) {
  protected selected: option.Valance | null = null;
  protected option = option;
  protected valanceList: option.Valance[] = Object.values(
    option.Valance
  ).filter(val => val !== option.Valance.Canopy);

  created(): void {
    this.readStoreData();
  }

  protected readStoreData(): void {
    if (this.valance) {
      this.selected = this.valance;
    } else {
      this.selected = option.Valance.Standard;
    }
  }

  protected async select(valance: option.Valance): Promise<void> {
    this.selected = valance;
    await this.$viewer.ChangeValance(valance);
    await this.addValance(valance);
    console.log("select valance", valance);
    // ToDo: Clear the fringe selection, if present if the option.valance is none/canopy
    console.log("stored valance", this.valance);
    this.$emit("valanceChanged", valance);
  }

  protected getValanceImage(val: option.Valance): string {
    const image = this.valanceImages[val];
    if (typeof image === "string") return image;
    if (!image) return "";
    return this.selected === val ? image.selected : image.default;
  }

  protected valanceLabels: Record<option.Valance, string> = {
    [option.Valance.Standard]: "Standard",
    [option.Valance.Whale]: "Whale Tail",
    [option.Valance.ClassicScallop]: "Classic Scallop",
    [option.Valance.ClassicScallopShort]: "Classic Scallop (Short)",
    [option.Valance.French]: "French",
    [option.Valance.Roman]: "Roman",
    [option.Valance.WaveScallop]: "Wave Scallop",
    [option.Valance.WaveScallopShort]: "Wave Scallop (Short)",
    [option.Valance.Canopy]: "Canopy"
  };

  protected formatValanceLabel(val: string): string {
    return val
      .split("-")
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  }

  protected valanceImages: Record<
    option.Valance,
    { default: string; selected: string } | string
  > = {
    [option.Valance.Standard]: {
      default: require("@/assets/images/valance-standard.svg"),
      selected: require("@/assets/images/valance-standard-selected.svg")
    },
    [option.Valance.ClassicScallopShort]: {
      default: require("@/assets/images/valance-classic-scallop-short.svg"),
      selected: require("@/assets/images/valance-classic-scallop-short-selected.svg")
    },
    [option.Valance.ClassicScallop]: {
      default: require("@/assets/images/valance-classic-scallop.svg"),
      selected: require("@/assets/images/valance-classic-scallop-selected.svg")
    },
    [option.Valance.French]: {
      default: require("@/assets/images/valance-french.svg"),
      selected: require("@/assets/images/valance-french-selected.svg")
    },
    [option.Valance.Roman]: {
      default: require("@/assets/images/valance-roman.svg"),
      selected: require("@/assets/images/valance-roman-selected.svg")
    },
    [option.Valance.WaveScallopShort]: {
      default: require("@/assets/images/valance-wave-scallop-short.svg"),
      selected: require("@/assets/images/valance-wave-scallop-short-selected.svg")
    },
    [option.Valance.WaveScallop]: {
      default: require("@/assets/images/valance-wave-scallop.svg"),
      selected: require("@/assets/images/valance-wave-scallop-selected.svg")
    },
    [option.Valance.Whale]: {
      default: require("@/assets/images/valance-whale-tail-v2.svg"),
      selected: require("@/assets/images/valance-whale-tail-selected.svg")
    },
    [option.Valance.Canopy]: "" // used to clear selection
  };

  protected toggleValanceModal(): void {
    UIkit.modal(document.getElementById("valance-modal") as HTMLElement).show();
  }
}
